import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import { ISchedules } from '../../../../services/journey.service';
import { useCreateAttendanceDeclarationMutation } from '../../../../services/schedule.service';
import { PDFGenerator } from '../../../../components/shared/PDFGenerator';
import PDFDocument from '../../../../components/pages/Journey/InformationAbout/PatientCare/PDFDocument';
import AttendanceDeclarationModel from '../model';

export default function DownloadItemViewModel({ schedule }: { schedule: ISchedules }) {
  const [createAttendanceDeclaration] = useCreateAttendanceDeclarationMutation();
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const generatePDF = async () => {
    if (loadingPDF) return;
    setLoadingPDF(true);
    try {
      const attendanceDeclaration = await createAttendanceDeclaration({ id: schedule.id }).unwrap();
      const blob = await pdf(
        React.createElement(PDFGenerator, null, React.createElement(PDFDocument, attendanceDeclaration)) as any
      ).toBlob();
      const pdfBlob = new Blob([blob], { type: 'application/octet-stream' });
      const url = URL.createObjectURL(pdfBlob);
      try {
        const link = document.createElement('a');
        link.href = url;
        link.download = `declaracao-de-comparecimento-${AttendanceDeclarationModel.formatDate(schedule.dateStart)}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setShowFeedback(true);
      } catch (err) {
        console.error(err);
      } finally {
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingPDF(false);
    }
  };

  const handleCloseFeedback = () => setShowFeedback(false);

  const label = `Declaração - ${AttendanceDeclarationModel.formatDate(schedule.dateStart)}`;

  return { loadingPDF, generatePDF, label, showFeedback, handleCloseFeedback };
}
